import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Stamp } from "lucide-react";
import { API, erreur } from "./outils";

// Signature et tampon du food truck employeur, deposes une fois puis
// imprimes sur ses contrats d'extras et ses bons de commande.
export default function SignatureEmployeur() {
  const [open, setOpen] = useState(false);
  const [image, setImage] = useState("");
  const [envoi, setEnvoi] = useState(false);

  useEffect(() => {
    if (!open) return;
    axios.get(`${API}/vivier/signature-employeur`)
      .then((r) => setImage(r.data.image || ""))
      .catch(() => {});
  }, [open]);

  const choisir = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    if (f.size > 1400000) return toast.error("Image trop lourde (1,4 Mo maximum)");
    const lecteur = new FileReader();
    lecteur.onload = () => setImage(String(lecteur.result));
    lecteur.readAsDataURL(f);
  };

  const enregistrer = async (retirer) => {
    setEnvoi(true);
    try {
      const r = await axios.put(`${API}/vivier/signature-employeur`, { image: retirer ? "" : image });
      if (retirer) setImage("");
      toast.success(r.data.message);
    } catch (e) {
      toast.error(erreur(e, "Enregistrement impossible"));
    }
    setEnvoi(false);
  };

  return (
    <>
      <Button variant="outline" onClick={() => setOpen(true)} data-testid="signature-employeur">
        <Stamp className="w-4 h-4 mr-1" /> Ma signature employeur
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-[460px]">
          <DialogHeader>
            <DialogTitle>Signature et tampon de votre food truck</DialogTitle>
          </DialogHeader>
          <div className="space-y-3">
            <p className="text-sm text-muted-foreground">
              Photographiez votre signature et votre tampon sur une feuille blanche. Ils seront
              imprimés sur les contrats et bons de commande de vos extras.
            </p>
            <input type="file" accept="image/png,image/jpeg" onChange={choisir} className="text-sm" />
            {image ? (
              <img src={image} alt="signature" className="border rounded-md bg-white max-h-40 mx-auto" />
            ) : (
              <p className="text-sm text-muted-foreground">Aucune signature enregistrée.</p>
            )}
          </div>
          <DialogFooter className="gap-2">
            {image && (
              <Button variant="outline" onClick={() => enregistrer(true)} disabled={envoi}>Retirer</Button>
            )}
            <Button onClick={() => enregistrer(false)} disabled={envoi || !image}>
              {envoi ? "..." : "Enregistrer"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
